import { MonthEnum } from '@/Module/Workspace/Model/Enum/monthEnum';
import type { TMonthFront } from '@/Module/Workspace/Model/Type';

export const MONTHS_VALUES: Record<TMonthFront, string> = {
  [MonthEnum.FARVARDIN]: 'فروردین',
  [MonthEnum.ORDIBEHESHT]: 'اردیبهشت',
  [MonthEnum.KHORDAD]: 'خرداد',
  [MonthEnum.TIR]: 'تیر',
  [MonthEnum.MORDAD]: 'مرداد',
  [MonthEnum.SHAHRIVAR]: 'شهریور',
  [MonthEnum.MEHR]: 'مهر',
  [MonthEnum.ABAN]: 'آبان',
  [MonthEnum.AZAR]: 'آذر',
  [MonthEnum.DEY]: 'دی',
  [MonthEnum.BAHMAN]: 'بهمن',
  [MonthEnum.ESFAND]: 'اسفند',
};
